import 'primeicons/primeicons.css';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.css';
import axios from 'axios';
import 'primeflex/primeflex.css';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import MenubarView from './MenubarView';
import { useEffect, useState} from 'react';



const AboutView = (props) => {
    const [entries, setEntries] = useState(null);

    useEffect(() => {
        fetchEntryData()
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const fetchEntryData = () => {
        const token = localStorage.getItem('bearerToken')
        const config = {
            headers: { Authorization: `Bearer ${token}` }
        };
        setEntries(null);
        const url =  '/v1/getConfigData'
        axios.get(url,config)
        .then(response => {
            setEntries(response.data)
        })
    }

    const mystyle = {
        display: 'block',
        marginLeft: 'auto',
        marginRight: 'auto',
        width: '50%',
        height: '50%'
    }

    if (entries === null) {
        return (
            <img alt='loading' style={mystyle} src='./logo.gif'/>
        )
    }
    else { 
    return (
        <div><div><MenubarView/></div>
        <br></br><br></br>
        <div className="card" style={{margin:'10px', borderColor:'steelBlue', border:'solid', borderRadius:'15px'}}>
            <DataTable value={entries} showGridlines sortMode="multiple" style={{margin:'10px'}}>
                <Column field="key"  sortable style={{'color':'steelBlue', fontWeight:'bold'}}></Column>
                <Column field="value" sortable style={{'color':'orange', fontWeight:'bold'}}></Column>
            </DataTable>
        </div>
    </div>
    );}
}
export default AboutView;